import { useEffect, useRef } from "react";
import uiState from "./data";
import Homepage from "./pages/Homepage.jsx";
import EnterPage from "./pages/EnterPage.jsx";
import CommunityPage from "./pages/CommunityPage.jsx";
import FactorySpa from "./pages/FactorySpa";
import FactoryEntrance from "./pages/FactoryEntrance";
import EnvironmentSpa from "./pages/EnvironmentSpa";
import SharedIframe from "./components/SharedIframe";
import TransitionPage from "./pages/TransitionPage";
import { useSnapshot } from "valtio";
import { isMobile } from "react-device-detect";

function App() {
  const { isMusicPlay, bgmSrc, controlForFQC } = useSnapshot(uiState.bgm);
  const { isInit } = useSnapshot(uiState.ga);

  // // 加入ga
  useEffect(() => {
    if (!isInit && !window.dataLayer) {
      // Dynamically insert the first script
      var script1 = document.createElement("script");
      script1.async = true;
      script1.src = "https://www.googletagmanager.com/gtag/js?id=G-S2764699YQ";

      // Dynamically insert the second script
      var script2 = document.createElement("script");
      script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag('js', new Date());
      gtag('config', 'G-S2764699YQ');
    `;

      // Append scripts to the head
      let head = document.querySelector("head");
      head.append(script1);
      head.append(script2);

      // Update state to ensure scripts are inserted only once
      uiState.ga.isInit = true;

      return () => {
        // Remove scripts when the component is unmounted
        head.removeChild(script1);
        head.removeChild(script2);
      };
    }
  }, [isInit]);

  const bgmRef = useRef();
  useEffect(() => {
    if (sessionStorage.getItem("isAuth")) {
      uiState.homepage.visible = true;
    } else {
      uiState.security.visible = true;
    }
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem("activePage") === "factoryChoose") {
      uiState.factoryEntrance.visible = true;
      uiState.homepage.visible = false;
    }
    if (sessionStorage.getItem("activePage") === "enterPage") {
      uiState.enterPage.visible = true;
      uiState.homepage.visible = false;
    }

    sessionStorage.setItem("activePage", "");
  }, []);

  useEffect(() => {
    // 定義一個處理 sessionStorage 變化的函式
    const iframeEvents = [
      "trumpetIframe",
      "saxIframe",
      "susIframe",
      "frenchhornIframe",
      "tromboneIframe",
    ];
    const hideAllIframes = () => {
      iframeEvents.forEach((key) => {
        uiState[key].visible = false;
      });
    };
    const handleSessionStorageChange = (event) => {
      if (event.key === "activeWeb") {
        // 在這裡處理 goPano 變化的相應動作
        if (event.newValue === "trumpet") {
          uiState.transitionPage.visible = true;
          if (bgmRef.current) {
            bgmRef.current.pause();
            uiState.bgm.bgmSrc = "../startImages/music/trumpet.mp3";
          }

          setTimeout(() => {
            uiState.transitionPage.text = uiState.transitionPage.data.trumpet;
            hideAllIframes();
            uiState.trumpetIframe.visible = true;
          }, 600);
          setTimeout(() => {
            let trumpetIframe = document.getElementById("trumpetIframe");

            if (bgmRef.current) {
              if (uiState.bgm.isMusicPlay && trumpetIframe?.contentWindow?.uiState?.bgm) {
                trumpetIframe.contentWindow.uiState.bgm.isMusicPlay = true;
                bgmRef.current.play();
              } else if (trumpetIframe?.contentWindow?.uiState?.bgm) {
                trumpetIframe.contentWindow.uiState.bgm.isMusicPlay = false;
              }
            }
          }, 1800);
          setTimeout(() => {
            uiState.transitionPage.visible = false;
            uiState.transitionPage.text = "";
          }, 3000);
        }
        if (event.newValue === "sax") {
          uiState.transitionPage.text = uiState.transitionPage.data.sax;
          uiState.transitionPage.visible = true;
          if (bgmRef.current) {
            bgmRef.current.pause();
            uiState.bgm.bgmSrc = "../startImages/music/sax.mp3";
          }

          setTimeout(() => {
            hideAllIframes();
            uiState.saxIframe.visible = true;
          }, 600);
          setTimeout(() => {
            let saxIframe = document.getElementById("saxIframe");

            if (bgmRef.current) {
              if (uiState.bgm.isMusicPlay && saxIframe?.contentWindow?.uiState?.bgm) {
                saxIframe.contentWindow.uiState.bgm.isMusicPlay = true;
                bgmRef.current.play();
              } else if (saxIframe?.contentWindow?.uiState?.bgm) {
                saxIframe.contentWindow.uiState.bgm.isMusicPlay = false;
              }
            }
          }, 1800);
          setTimeout(() => {
            uiState.transitionPage.visible = false;
            uiState.transitionPage.text = "";
          }, 3000);
        }
        if (event.newValue === "frenchhorn") {
          uiState.transitionPage.text = uiState.transitionPage.data.frenchhorn;
          uiState.transitionPage.visible = true;
          if (bgmRef.current) {
            bgmRef.current.pause();
            uiState.bgm.bgmSrc = "../startImages/music/hn.mp3";
          }

          setTimeout(() => {
            hideAllIframes();
            uiState.frenchhornIframe.visible = true;
          }, 600);
          setTimeout(() => {
            let frenchhornIframe = document.getElementById("frenchhornIframe");

            if (bgmRef.current) {
              if (
                uiState.bgm.isMusicPlay &&
                frenchhornIframe?.contentWindow?.uiState?.bgm
              ) {
                frenchhornIframe.contentWindow.uiState.bgm.isMusicPlay = true;
                bgmRef.current.play();
              } else if (frenchhornIframe?.contentWindow?.uiState?.bgm) {
                frenchhornIframe.contentWindow.uiState.bgm.isMusicPlay = false;
              }
            }
          }, 1800);
          setTimeout(() => {
            uiState.transitionPage.visible = false;
            uiState.transitionPage.text = "";
          }, 3000);
        }
        if (event.newValue === "trombone") {
          uiState.transitionPage.text = uiState.transitionPage.data.trombone;
          uiState.transitionPage.visible = true;
          if (bgmRef.current) {
            bgmRef.current.pause();
            uiState.bgm.bgmSrc = "../startImages/music/tb.mp3";
          }

          setTimeout(() => {
            hideAllIframes();
            uiState.tromboneIframe.visible = true;
          }, 600);
          setTimeout(() => {
            let tromboneIframe = document.getElementById("tromboneIframe");

            if (bgmRef.current) {
              if (uiState.bgm.isMusicPlay && tromboneIframe?.contentWindow?.uiState?.bgm) {
                tromboneIframe.contentWindow.uiState.bgm.isMusicPlay = true;
                bgmRef.current.play();
              } else if (tromboneIframe?.contentWindow?.uiState?.bgm) {
                tromboneIframe.contentWindow.uiState.bgm.isMusicPlay = false;
              }
            }
          }, 1800);
          setTimeout(() => {
            uiState.transitionPage.visible = false;
            uiState.transitionPage.text = "";
          }, 3000);
        }

        if (event.newValue === "sus") {
          uiState.transitionPage.text = uiState.transitionPage.data.sus;
          uiState.transitionPage.visible = true;
          if (bgmRef.current) {
            bgmRef.current.pause();
            uiState.bgm.bgmSrc = "../startImages/music/sus.mp3";
          }

          setTimeout(() => {
            hideAllIframes();
            uiState.susIframe.visible = true;
          }, 600);
          setTimeout(() => {
            let susIframe = document.getElementById("susIframe");

            if (bgmRef.current) {
              if (uiState.bgm.isMusicPlay && susIframe?.contentWindow?.uiState?.bgm) {
                susIframe.contentWindow.uiState.bgm.isMusicPlay = true;
                bgmRef.current.play();
              } else if (susIframe?.contentWindow?.uiState?.bgm) {
                susIframe.contentWindow.uiState.bgm.isMusicPlay = false;
              }
            }
          }, 1800);
          setTimeout(() => {
            uiState.transitionPage.visible = false;
            uiState.transitionPage.text = "";
          }, 3000);
        }
      }

      if (event.key === "reload") {
        if (sessionStorage.getItem("isAuth")) {
          sessionStorage.clear();
          sessionStorage.setItem("isAuth", true);
        }

        window.location.reload();
      }

      if (event.key === "activePage") {
        if (event.newValue === "susMainPage") {
          let mutePage = ["enterPage", "homepage", "factoryEntrance"];
          let iframe = [
            "trumpetIframe",
            "saxIframe",
            "susIframe",
            "frenchhornIframe",
            "tromboneIframe",
          ];
          mutePage.map((el) => (uiState[el].visible = false));
          uiState.environmentSpa.visible = true;

          setTimeout(() => {
            iframe.map((el) => (uiState[el].visible = false));
            sessionStorage.setItem("activePage", "");
            if (bgmRef.current) {
              bgmRef.current.pause();
            }
          }, 500);
        }
      }
    };

    window.addEventListener("storage", handleSessionStorageChange);
    return () => {
      window.removeEventListener("storage", handleSessionStorageChange);
    };
  }, []);
  useEffect(() => {
    if (bgmRef.current) {
      bgmRef.current.volume = 0.6;
      if (isMusicPlay) {
        if (!isMobile && controlForFQC) {
          let volumeInterval;
          let volume = 0;
          bgmRef.current.volume = 0;
          bgmRef.current.play();
          volumeInterval = setInterval(() => {
            volume += 0.01;
            if (volume < 0.6) {
              bgmRef.current.volume = volume;
            } else {
              clearInterval(volumeInterval);
            }
          }, 30);
        } else {
          bgmRef.current.play();
        }
      } else {
        if (!isMobile && controlForFQC) {
          let volumeInterval;
          let volume = 0.6;
          volumeInterval = setInterval(() => {
            volume -= 0.01;
            if (volume > 0) {
              bgmRef.current.volume = volume;
            } else {
              clearInterval(volumeInterval);
              bgmRef.current.pause();
            }
          }, 30);
        } else {
          bgmRef.current.pause();
        }
      }
    }
  }, [isMusicPlay, controlForFQC]);

  return (
    <div className="App select-none tracking-widest overscroll-none ">
      <audio
        controls
        loop
        controlsList="nodownload noplaybackrate "
        id="bgm"
        src={bgmSrc}
        ref={bgmRef}
        className="absolute top-0 right-0  pointer-events-none hidden"
      ></audio>
      <Homepage event="homepage" />
      <EnterPage event="enterPage" />
      <CommunityPage event="communityPage" />
      <FactoryEntrance event="factoryEntrance" />
      <FactorySpa event="factorySpa" />
      <EnvironmentSpa event="environmentSpa" />
      <SharedIframe />
      <TransitionPage event="transitionPage" />
    </div>
  );
}

export default App;
